/*
  Correctifs maison du tunnel de verres, Les Lunettes de Pauline.

  Ils sont poses ici plutot que dans lens-tunnel.js, qui est minifie sur une seule
  ligne et ne peut pas etre modifie sans risque. Chaque correctif est autonome et
  sans effet si le defaut qu'il vise a disparu, il peut donc etre retire bloc par
  bloc le jour ou la correction sera faite a la source.

  Charge par sections/lens-tunnel.liquid, uniquement sur les fiches ou le tunnel
  s'affiche. Ce fichier charge a son tour lt-garde-fous.js (correctif 4), pour
  eviter d'avoir a modifier la section.
*/
(function () {
  'use strict';

  /* Chargement de lt-garde-fous.js, a partir de l'adresse de ce fichier. */
  (function () {
    var moi = document.currentScript;
    if (!moi || !moi.src) { return; }
    var url = moi.src.replace('lt-correctifs', 'lt-garde-fous');
    if (url === moi.src) { return; }
    var s = document.createElement('script');
    s.src = url;
    s.defer = true;
    document.head.appendChild(s);
  })();

  /*
    Correctif 1. La phrase de recommandation affichee dans l'encart .lt-reco est
    ecrite en dur dans lens-tunnel.js. Depuis que le seuil de recommandation du
    1.6 est passe a 2 dioptries dans lens-map.json, la formule d'origine ("Votre
    correction est assez marquee") est exageree. On remplace le texte au moment
    de l'affichage.
  */
  var AVANT = "Votre correction est assez marquée : un verre aminci 1.6 sera plus fin et plus léger.";
  var APRES = "Sur cette correction, un verre aminci 1.6 sera sensiblement plus fin et plus léger.";

  function corriger(n) {
    if (!n || n.nodeType !== 1) { return; }
    var liste = [];
    if (n.classList && n.classList.contains('lt-reco')) { liste.push(n); }
    if (n.querySelectorAll) {
      var trouves = n.querySelectorAll('.lt-reco');
      for (var j = 0; j < trouves.length; j++) { liste.push(trouves[j]); }
    }
    for (var i = 0; i < liste.length; i++) {
      var t = liste[i].textContent;
      if (t && t.indexOf(AVANT) !== -1) { liste[i].textContent = t.split(AVANT).join(APRES); }
    }
  }

  function demarrer() {
    corriger(document.body);
    ordoStyle();
    ordoTraiter(document.body);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        ordoTraiter(mutations[i].target);
        var ajouts = mutations[i].addedNodes;
        for (var k = 0; k < ajouts.length; k++) { corriger(ajouts[k]); ordoTraiter(ajouts[k]); }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', demarrer); }
  else { demarrer(); }

  /*
    Correctif 2. Sur l'etape 2 du tunnel (Transparents ou solaires), le bouton
    Continuer n'a aucun effet : le gestionnaire de lens-tunnel.js exclut
    explicitement cette etape et l'avancement se fait uniquement au clic sur une
    carte. Le defaut ne se voit qu'au retour depuis l'etape 3, quand une carte
    est deja selectionnee et que le bouton n'est donc plus grise : il semble
    actif et ne repond pas.
  */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    if (!e.target.closest('#lt-next')) { return; }
    var scene = document.querySelector('#lt-stage');
    if (!scene) { return; }
    var carte = scene.querySelector('[data-typ2].sel');
    if (!carte) { return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    carte.click();
  }, true);

  /*
    Correctif 3. Ordonnance obligatoire.

    La correction saisie dans le tunnel ne quitte jamais le navigateur du client :
    elle sert au devis et a la recommandation d'epaisseur, elle n'est ni transmise
    ni stockee. Les textes d'origine le disaient trop doucement, en particulier
    "Pas besoin de la joindre ici", qui se lit comme si l'ordonnance etait
    facultative. On reecrit les trois endroits ou le sujet apparait.
  */
  var CSS = ''
    + '.lt-scope .lt-ordo-fort{background:var(--lt-accent-soft);border:1px solid var(--lt-accent-dk);'
    + 'border-radius:6px;padding:13px 15px;margin:16px 0 2px;}'
    + '.lt-scope .lt-ordo-fort p{margin:0;font-size:13.5px;line-height:1.6;color:var(--lt-accent-dk);}'
    + '.lt-scope .lt-ordo-ligne{margin-top:14px;font-size:13px;line-height:1.55;color:var(--lt-muted);}'
    + '.lt-scope .lt-ordo-ligne strong{color:var(--lt-accent-dk);}';

  function ordoStyle() {
    if (document.getElementById('lt-ordo-css')) { return; }
    var s = document.createElement('style');
    s.id = 'lt-ordo-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  var ETAPE1_AVANT = 'Pas besoin de la joindre ici';
  var ETAPE1_APRES = ''
    + '<strong>Votre ordonnance est indispensable.</strong> '
    + 'La correction que vous saisissez ici sert uniquement à établir votre devis et à vous conseiller '
    + "l'épaisseur de verre : elle reste sur votre appareil et ne nous est jamais transmise. Nous ne l'avons donc pas. "
    + "Pour fabriquer vos verres, c'est votre ordonnance qui fait foi. Juste après votre commande, vous recevrez un "
    + 'e-mail avec un lien sécurisé (hébergement <strong>certifié HDS</strong>, dédié aux données de santé) pour nous '
    + "l'envoyer. Vous pouvez aussi l'apporter en magasin à Craponne.";

  var FIN_AVANT = 'Apres votre paiement, vous recevrez un e-mail';
  var FIN_APRES = ''
    + "<strong>Dernière étape, votre ordonnance.</strong> Nous n'avons pas reçu la correction que vous venez de "
    + 'saisir, elle est restée sur votre appareil. Pour que nous puissions commander et monter vos verres, '
    + "envoyez-nous votre ordonnance avec le lien sécurisé que vous trouverez dans l'e-mail de confirmation de "
    + "commande (hébergement certifié HDS). Vous pouvez aussi l'apporter en magasin à Craponne. Tant que nous ne "
    + "l'avons pas, la fabrication ne peut pas démarrer.";

  var RECAP_HTML = ''
    + '<p class="lt-ordo-ligne"><strong>Ordonnance à nous envoyer après la commande</strong>, par le lien sécurisé '
    + "reçu par e-mail. La correction saisie ici n'est pas enregistrée chez nous.</p>";

  function sansAccents(t) {
    try { return t.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { return t; }
  }

  function ordoTraiter(racine) {
    if (!racine || racine.nodeType !== 1 || !racine.querySelectorAll) { return; }

    var ordo = racine.querySelectorAll('.lt-ordo p');
    for (var i = 0; i < ordo.length; i++) {
      var p = ordo[i];
      if (p.getAttribute('data-ordo') === 'fait') { continue; }
      if (sansAccents(p.textContent).indexOf(ETAPE1_AVANT) === -1) { continue; }
      p.innerHTML = ETAPE1_APRES;
      p.setAttribute('data-ordo', 'fait');
    }

    var ps = racine.querySelectorAll('#lt-stage p');
    for (var j = 0; j < ps.length; j++) {
      var q = ps[j];
      if (q.getAttribute('data-ordo') === 'fait') { continue; }
      if (sansAccents(q.textContent).indexOf(FIN_AVANT) === -1) { continue; }
      var box = document.createElement('div');
      box.className = 'lt-ordo-fort';
      box.setAttribute('data-ordo', 'fait');
      box.innerHTML = '<p>' + FIN_APRES + '</p>';
      q.parentNode.replaceChild(box, q);
    }

    var legal = racine.querySelectorAll('#lt-stage .lt-legal');
    for (var k = 0; k < legal.length; k++) {
      var l = legal[k];
      if (l.getAttribute('data-ordo') === 'fait') { continue; }
      if (sansAccents(l.textContent).indexOf('Sans droit de retractation') === -1) { continue; }
      var avant = document.createElement('div');
      avant.innerHTML = RECAP_HTML;
      l.parentNode.insertBefore(avant.firstChild, l);
      l.setAttribute('data-ordo', 'fait');
    }
  }
})();